function initCustomVideoSkin() {
  const videoPlayers = document.querySelectorAll('.custom-video-player');
  if (videoPlayers.length) {
    videoPlayers.forEach((player) => {
      const video = player.querySelector('video');
      const playPauseBtn = player.querySelector(
        '.custom-video-player__playPauseBtn',
      );
      const progressBar = player.querySelector(
        '.custom-video-player__progressBar',
      );
      const muteBtn = player.querySelector('.custom-video-player__muteBtn');
      const volumeBarWrap = player.querySelector(
        '.custom-video-player__volumeBar-wrap',
      );
      const volumeBar = player.querySelector('.custom-video-player__volumeBar');

      const fullscreenBtn = player.querySelector(
        '.custom-video-player__fullscreenBtn',
      );
      const currentTimeDisplay = player.querySelector(
        '.custom-video-player__currentTime',
      );

      // range fill, place the <input> and fill inside container <span>
      let rangeFill = document.createElement('span');
      rangeFill.className = 'range__input-fill';
      // volumeBar.appendChild(this.el);
      volumeBarWrap.appendChild(rangeFill);
      // this.fill = rangeFill;

      // Play/Pause button
      playPauseBtn.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          playPauseBtn.classList.remove('paused');
          playPauseBtn.classList.add('paused');
        } else {
          video.pause();
          playPauseBtn.classList.remove('paused');
          playPauseBtn.classList.add('playing');
        }
      });

      // Update progress bar and current time display as the video plays
      video.addEventListener('timeupdate', function () {
        const progress = (video.currentTime / video.duration) * 100;
        progressBar.value = progress;
        currentTimeDisplay.textContent = formatTime(video.currentTime);
      });

      // Seek video when progress bar is changed
      progressBar.addEventListener('input', function () {
        const seekTime = (progressBar.value / 100) * video.duration;
        video.currentTime = seekTime;
      });

      // Mute/Unmute button
      muteBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        muteBtn.textContent = video.muted ? 'Unmute' : 'Mute';
      });

      // Volume control
      volumeBar.addEventListener('input', function () {
        console.log(volumeBar.value);
        rangeFill.style.width = volumeBar.value * 100 + '%';
        if (volumeBar.value > 0) {
          console.log('greater');
          video.muted = false;
        } else {
          console.log('less');
          video.muted = true;
        }
        video.volume = volumeBar.value;
      });

      // Fullscreen button
      fullscreenBtn.addEventListener('click', function () {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.mozRequestFullScreen) {
          video.mozRequestFullScreen();
        } else if (video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) {
          video.msRequestFullscreen();
        }
      });

      // Format time (seconds to mm:ss)
      function formatTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
      }

      // Set initial current time display
      video.addEventListener('loadedmetadata', function () {
        currentTimeDisplay.textContent = formatTime(video.duration);
      });
    });
  }
}

export default initCustomVideoSkin;
